<div fxFlex="0 0 100%" fxLayout="row wrap" class="assignments-select">
    <app-sticky-header
        class="sticky-header"
        [title]="data.title"
        [context]="data.context"
        [contextIcon]="data.contextIcon"
        (onSubmit)="submit()"
        (onCancel)="bottomSheetRef.dismiss(data)"
        [savingStatus]="saving"
    ></app-sticky-header>
    <div class="sticky-info">
        <mat-icon>info</mat-icon>
        <span i18n>Add this item into a Folder or Section</span>
    </div>
    <mat-tab-group class="sticky-after-info user-manage-cp-access" fxFlex="0 0 90%" ngClass.xs="xs">
        <mat-tab>
            <ng-template mat-tab-label>
                <span i18n="@@sections">Sections</span>
            </ng-template>
            <app-section-select
                scope="customer"
                [params]="[{ property: 'stream', items: [false] }]"
                [hideTools]="true"
                [accessForm]="assignForm"
                referenceFilter="referenceResource"
            ></app-section-select>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <span i18n="@@folders">Folders</span>
            </ng-template>
            <app-folder-select
                [hideTools]="true"
                [accessForm]="assignForm"
                referenceFilter="referenceResource"
            ></app-folder-select>
        </mat-tab>
    </mat-tab-group>
</div>
